import { Button, Link, Stack, Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import BorderBoxReset from '~/components/util/BorderBoxReset';
import useToggleRuntimeVariable from '../../../../../../hooks/runtime/useToggleRuntimeVariable';
import useToggle from '../../../../../../hooks/useToggle';
import ExportableFilterModal from '../../../../../Search/components/ExportableFilterModal';

type Props = {
  visitType: 'upcoming' | 'past';
};

const EmptyState = ({ visitType }: Props) => {
  const [, toggleAccountDrawer] = useToggleRuntimeVariable('account-drawer');
  const [open, toggleSearchModal] = useToggle();

  const { t } = useTranslation(['account', 'common']);

  return (
    <Stack alignItems="center" px={3} py={6} space={5} textAlign="center">
      <Stack alignItems="center" space={3}>
        <img height={128} src="/images/account/calendar-spot-icon.svg" width={128} />

        <Stack space={1}>
          <Text variant="h3">{t(`account:manage.emptyState.title.${visitType}` as const)}</Text>
          <Text muted>{t('account:manage.emptyState.title.subtitile')}</Text>
        </Stack>
      </Stack>

      <Button fullWidth onClick={toggleSearchModal} variant="outlined">
        {t('account:manage.emptyState.cta')}
      </Button>

      <Text muted variant="body2">
        <Trans i18nKey="account:manage.emptyState.switchProfilesCta" t={t}>
          <Link inline onClick={toggleAccountDrawer} size="small" sx={{ wordBreak: 'break-all' }}>
            Change Profiles
          </Link>
        </Trans>
      </Text>

      <ExportableFilterModal
        closeModal={toggleSearchModal}
        HeaderProps={{
          onCancel: toggleSearchModal,
          cancelCopy: t('common:cancel'),
          confirmCopy: t('common:search'),
        }}
        modalOpen={open}
        showSolvPlusEntrypoint
        title={t('account:searchModal.titles.findCare')}
      />
    </Stack>
  );
};

export default EmptyState;
